import { createSlice } from '@reduxjs/toolkit';
import { createAppAsyncThunk } from '../../createAppAsyncThunk';
import { API_POST } from '../../../services';
import { YardRXModel } from '../../../models/YardRXModel';
import type { RootState } from '../../store';
import { env } from '../../../env';
import { ENDPOINTS } from '../../../constants/endPoints';
import { RADRequest } from '../../../models/common/RADRequest';

interface YardRxState {
  data: YardRXModel | null;
  isLoading: boolean;
}

const initialState: YardRxState = {
  data: null,
  isLoading: false,
};

// Async thunk to fetch Yard RX data
export const fetchYardRx = createAppAsyncThunk(
  'ecommerce/fetchYardRx',
  async (payload: RADRequest) => {
    const requestBody = {
      StoreNumber: payload.storeNumber,
      IsMultiStoreMode: payload.isMultiStoreMode,
    };

    const response = await API_POST(`${env.RAD_APP_API_URL}${ENDPOINTS.GET_YARD_RX}`, requestBody);
    return response as YardRXModel;
  },
);

// Yard RX slice
const yardRxSlice = createSlice({
  name: 'yardRx',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchYardRx.pending, state => {
        state.isLoading = true;
      })
      .addCase(fetchYardRx.fulfilled, (state, action) => {
        state.data = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchYardRx.rejected, state => {
        state.data = null;
        state.isLoading = false;
      });
  },
});

// Selectors
export const selectYardRx = (state: RootState) => state.yardRx.data;
export const selectYardRxLoading = (state: RootState) => state.yardRx.isLoading;

export default yardRxSlice.reducer;
